import React from "react";
import { Route } from "react-router-dom";
import TransactionUpdate from "../../../containers/modules/log/transaction-update";

export default function TransactionUpdateRoute(props) {
  const { authUser } = props;
  return (
    <Route
      path="transaction-update"
      index
      element={
        <TransactionUpdate />
      }
    />
  );
}
